import { memo } from 'react';
import { fill_vertical_cross_center } from '~/modules/AppLayout/FlexGridCss';
import styled from '@emotion/styled';
import { proxy } from 'valtio';
import { OrderDrawerButton } from './component/ordersPane/OrderDrawerButton';
export const investment_store = proxy({
    pageView: 'signal-wall',
});
//todo: 是否需要使用 盤中/盤後分類
export const Investment_SidePaneMenu = memo(function Investment_SidePaneMenu() {
    return (<classes.container>
      <classes.linkItem>大盤概況</classes.linkItem>
      {/* 像是首頁的概念 */}
      <classes.link onClick={() => (investment_store.pageView = 'market-view')}>
        -綜合報價
      </classes.link>
      {/* 舊版的權值股報價磚 */}
      <classes.link>-權值股監控</classes.link>
      {/* 帶有前10走勢圖的權值股報價 */}
      <classes.link>-權值股看盤</classes.link>
      <classes.linkItem>期貨</classes.linkItem>
      {/* 新版期貨看盤 */}
      <classes.link onClick={() => (investment_store.pageView = 'vip-trader')}>
        -VIP看盤室
      </classes.link>
      <classes.linkItem>選擇權</classes.linkItem>
      <classes.link onClick={() => (investment_store.pageView = 'option-quote')}>
        -選擇權報價
      </classes.link>
      <classes.link onClick={() => (investment_store.pageView = 'option-opbs')}>
        -選擇權分析
      </classes.link>
      <classes.linkItem>大盤籌碼</classes.linkItem>
      <classes.linkItem>營收追蹤</classes.linkItem>
      <classes.link onClick={() => (investment_store.pageView = 'realtime-revenue')}>
        -即時營收
      </classes.link>
      <classes.link>-營收排行</classes.link>
      <classes.linkItem>選股策略</classes.linkItem>
      <classes.link onClick={() => (investment_store.pageView = 'screener-base')}>
        -快速選股
      </classes.link>
      <classes.linkItem>即時監控</classes.linkItem>
      <classes.link onClick={() => (investment_store.pageView = 'signal-wall')}>
        -動向監控
      </classes.link>
      <classes.link onClick={() => (investment_store.pageView = 'daytrade-analyze')}>
        -當沖分析
      </classes.link>
      <classes.link onClick={() => (investment_store.pageView = 'pre-market')}>
        -盤前試搓
      </classes.link>
      <OrderDrawerButton />
    </classes.container>);
});
const classes = {
    container: styled.div `
    ${fill_vertical_cross_center};
    align-items: start;
    background-color: #252525;
    padding: 2px;
    gap: 4px;
    border-right: 1px solid #777777;
    font-size: 14px;
  `,
    linkItem: styled.div `
    color: #999999;
    font-weight: 700;
  `,
    link: styled.div `
    color: #eeeeee;
    font-size: 13px;
    margin-left: 8px;
    cursor: pointer;
  `,
};
